import React from 'react'
import {urls} from '../../config'
import { footer, titleWhite, titlePink, footerContain, leftSide, linksWebsites, lastLine, rightSide, linkContain } from './footer.module.css'
import {SocialMediaFooter} from 'components/SocialMedia/'

export default props => (
  <footer className={footer}>
    <div
      className={props.theme === 0
      ? titleWhite
      : titlePink}>
      <h2>Villa Rossa</h2>
    </div>
    <div className={footerContain}>
      <div className={leftSide}>
        <div className={linksWebsites}>
          <a
            style={{
              fontWeight: '100'
            }}
            href={'https://location-palombaggia.com'}>
            Palombaggia
          </a>
          {/* <a
            href={'https://villas-rossa.com'}
          >
            Cala Rossa
          </a> */}
        </div>
        <div className={lastLine}></div>
      </div>
      <div className={rightSide}>
        <a
          href={'https://comdeslezards.com'}
          rel="nofollow"
          style={{
          textDecoration: 'none',
          color: 'initial'
        }}>
          <h5 style={{
            fontWeight: '500'
          }}>©COM DES LEZARDS, 2018</h5>
        </a>
        <SocialMediaFooter lang={props.lang}/>
      </div>
    </div>
  </footer>
)

export const FooterPreviousVersion = props => <footer className={footer}>
  <div
    className={props.theme === 0
    ? titleWhite
    : titlePink}>
    <h2>Villa Rossa</h2>
  </div>
  <div className={footerContain}>
    <div className={leftSide}>
      <div className={linksWebsites}>
        <a href={props.baseUrl + urls.palombagia}>Palombagia</a>
      </div>
      <div className={lastLine}>
        <h5>©COM DES LEZARDS, 2018</h5>
        <SocialMediaFooter lang={props.lang}/>
      </div>
    </div>
    <div className={rightSide}>
      <div className={linkContain}>
        Villa Rossa - Palombagia MarinaRossa - Copyright
      </div>
    </div>
  </div>
</footer>
